<template>
  <div>
    <v-row class="grey darken-4 mx-0 rounded">
      <v-col cols="6" md="4" sm="3" class="align-self-center">
        <v-text-field
          :label="$t('labels.termoBusca')"
          :placeholder="$t(`labels.data`)"
          class="text-caption"
          outlined
          dense
          persistent-hint
          dark
          max="currentDate"
          :maxlength="10"
          :type="'date'"
          v-model="searchFields.data"
        />
      </v-col>
    </v-row>
    <index-buttons
      @search="sendSearch('search')"
      @register="create()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <v-row>
      <v-col cols="12">
        <div>
          <span
            class="text-h5 font-weight-thin black--text"
            style="user-select: none"
          >
            {{ $tc('labels.cambio') }}</span
          >
          <span
            class="text-h5 font-weight-light green--text text--darken-1 ml-2"
            style="user-select: none"
            color="red"
            >{{ $t('labels.atual') }}</span
          >
        </div>
        <v-data-table
          dense
          dark
          hide-default-footer
          :headers="tableHeaderSelected"
          :items="currency"
          :loading="loadingItems"
          :show-select="false"
          :single-select="false"
          item-key="DATAHORA"
        >
          <template v-slot:item.DATAHORA="{ item }">
            {{ formatDate(item.DATAHORA) }}
          </template>
          <template v-slot:item.CAMBIO0="{ item }">
            {{ formatCurrency(0, item.CAMBIO0) }}
          </template>
          <template v-slot:item.CAMBIO1="{ item }">
            {{ formatCurrency(1, item.CAMBIO1) }}
          </template>
          <template v-slot:item.CAMBIO2="{ item }">
            {{ formatCurrency(2, item.CAMBIO2) }}
          </template>
          <template v-slot:item.CAMBIO3="{ item }">
            {{ formatCurrency(3, item.CAMBIO3) }}
          </template>
          <template v-slot:item.CAMBIO4="{ item }">
            {{ formatCurrency(4, item.CAMBIO4) }}
          </template>
          <template v-slot:item.CAMBIO5="{ item }">
            {{ formatCurrency(5, item.CAMBIO5) }}
          </template>
          <template v-slot:item.controls="props">
            <v-btn-toggle tile>
              <!-- <v-btn class="mr-1" fab x-small color="warning" @click="goToRoute(props.item)">
                            <v-icon dark>mdi-pen</v-icon>
                        </v-btn> -->
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="doDelete(props.item)"
                :disabled="opering"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <span
            class="text-h5 font-weight-thin black--text"
            style="user-select: none"
            >{{ $tc('labels.cambio', 2) }}</span
          >
          <span
            class="text-h5 font-weight-light green--text text--darken-1 ml-2"
            style="user-select: none"
            >{{ $tc('labels.anterior', 2) }}</span
          >
        </div>
        <v-data-table
          dense
          dark
          hide-default-footer
          :headers="tableHeaderSelected"
          :items="currencyList"
          :loading="loadingItems"
          :show-select="false"
          :single-select="false"
          item-key="DATA"
        >
          <template v-slot:item.DATAHORA="{ item }">
            {{ formatDate(item.DATAHORA) }}
          </template>
          <template v-slot:item.CAMBIO0="{ item }">
            {{ formatCurrency(0, item.CAMBIO0) }}
          </template>
          <template v-slot:item.CAMBIO1="{ item }">
            {{ formatCurrency(1, item.CAMBIO1) }}
          </template>
          <template v-slot:item.CAMBIO2="{ item }">
            {{ formatCurrency(2, item.CAMBIO2) }}
          </template>
          <template v-slot:item.CAMBIO3="{ item }">
            {{ formatCurrency(3, item.CAMBIO3) }}
          </template>
          <template v-slot:item.CAMBIO4="{ item }">
            {{ formatCurrency(4, item.CAMBIO4) }}
          </template>
          <template v-slot:item.CAMBIO5="{ item }">
            {{ formatCurrency(5, item.CAMBIO5) }}
          </template>
          <template v-slot:item.controls="props">
            <v-btn-toggle tile>
              <!-- <v-btn class="mr-1" fab x-small color="warning" @click="openRegister(props.item)">
                            <v-icon dark>mdi-pen</v-icon>
                        </v-btn> -->
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="doDelete(props.item)"
                :disabled="opering"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-btn
      v-shortkey.once="['alt', 'r']"
      @shortkey="openRegister()"
      v-show="false"
    />
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          :length="pagination.last_page"
          :total-visible="pagination.per_page"
          v-model="pagination.current_page"
          @input="changePage($event)"
          :disabled="loadingItems"
        >
        </v-pagination>
      </v-col>
    </v-row>
    <confirm ref="confirm" v-model="confirm" />
    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
import IndexButtons from '@/components/shared/base-buttons/IndexButtons'

export default {
  components: { Confirm, IndexButtons },
  mixins: [tableMixin, headerMixin, currencyMixin],
  data: () => {
    return {
      headerName: 'currencyIndex',
      confirm: false,
      searchFields: {
        data: '',
        page: 1,
      },
      header: [],
      tableHeaderAvaiable: [
        {
          label: 'data',
          text: 'Data',
          value: 'DATAHORA',
          align: 'start',
          show: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getCurrencies: 'systemModule/getSystemCurrencies',
      authUser: 'authModule/getAuthUser',
    }),
    ...mapState('currencyModule', [
      'currencyList',
      'currency',
      'loadingItems',
      'opering',
      'pagination',
    ]),
    currentDate() {
      const date = new Date()
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      return year + '-' + month + '-' + day
    },
    headerList() {
      const header = []
      header.push({
        label: 'data',
        text: 'Data',
        value: 'DATAHORA',
        show: true,
        // width: this.$vuetify.breakpoint.mobile ? 120 : 180,
      })
      if (this.authUser)
        this.getCurrencies.forEach((element, index) => {
          header.push({
            text: element.descricao,
            value: `CAMBIO${index}`,
            show: true,
          })
        })
      header.push({
        label: 'acoes',
        text: 'Ações',
        value: 'controls',
        width: 60,
        align: 'end',
        show: true,
      })

      let retorno = header.map((element) => {
        if (element.label)
          element.text = this.$i18n.t(`labels.${element.label}`)

        return element
      })
      return retorno
    },
  },
  methods: {
    ...mapActions({
      getCurrencyAPI: 'currencyModule/getCurrency',
      deleteCurrency: 'currencyModule/deleteCurrency',
    }),
    changePage(page) {
      if (page) this.searchFields.page = page
      else this.searchFields.page = this.pagination.currentPage
      this.sendSearch('page')
    },
    updateHeader() {
      this.getCurrencies.forEach((el, index) => {
        this.tableHeaderAvaiable.push({
          label: el.descricao,
          text: el.descricao,
          value: `CAMBIO${index}`,
          show: true,
        })
      })
      this.tableHeaderAvaiable.push({
        label: 'acoes',
        text: 'Ações',
        value: 'controls',
        align: 'right',
        show: true,
      })
    },
    async sendSearch(type = 'search') {
      try {
        let search
        if (type == 'search' && this.searchFields.data) {
          this.searchFields.page = 1
        }
        search = this.searchFields
        await this.getCurrencyAPI(search)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    create() {
      this.$router.push({ name: 'currency.register' })
    },
    formatDate(date, withTime = false) {
      let dateTimeArray = date.split(' ')
      let dateArray = dateTimeArray[0].split('-')
      let timeArray = dateTimeArray[1].split(':')
      if (withTime)
        return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} ${timeArray[0]}h${timeArray[1]}m${timeArray[2]}`
      else return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`
    },
    async doDelete(item) {
      try {
        if (
          await this.$refs.confirm.open(
            `${this.$t('labels.exclusao')}`,
            `${this.$t('dialogs.doDeleteCambio', {
              data: this.formatDate(item.DATAHORA),
            })}`,
            { color: 'red darken-3' }
          )
        ) {
          let response = await this.deleteCurrency(item)
          this.$toasted.success(response)
        } else {
          return
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  async mounted() {
    await this.sendSearch()
    await this.updateHeader()
    this.mountHeader()
  },
}
</script>

<style></style>
